import CartTextil from './CartTextil';

export default CartTextil;